import React from 'react';
import { EditableInfo } from '@icoach/components';

const MemoBox = ({ className, memo, onEdit }) => {
    return (
        <EditableInfo label="備註" onEdit={onEdit} className={className} isMultiline>
            {memo}
        </EditableInfo>
    );
};

export default MemoBox;
